/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { CrownOutlined, SearchOutlined, WarningOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, Button } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectCurrentUser } from 'Store/user/selector'
import { formatDateWithoutTime, getMenuTypeName, getPointStatus, numberWithComma } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { PrimaryButton } from 'Components/button'
import { Pagination } from 'Components/Pagination'
import { menuPointUserType } from 'helpers/constanst'
import { SelectItem } from 'Components/form'
import { pointListAPI } from 'Store/point/api'
import { PointListData, PointListReq } from 'Store/point/types'
import { selectPointList } from 'Store/point/selector'
import theme from 'Components/common/Theme'

type Props = {} & ReduxProps

const EarnPoint: React.FunctionComponent<Props> = props => {
  const { currentUser, pointList } = props
  const dispatch = useDispatch()
  const [isFilterByUser, setiIsFilterByUser] = useState(false)

  const [filter, setFilter] = useState({
    keyword: '',
    start_date: '',
    end_date: '',
    status: '',
    type: 'buyer',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = pointList.meta
  const datas = pointList.data
  const listEvent = pointList.event

  const onGetDataList = (): void => {
    const req: PointListReq = {
      keyword: filter.keyword?.trim() || '',
      status: filter.status,
      type: filter.type,
      is_expired: false,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
    }
    if (filter.keyword !== '' && filter.type !== '') {
      setiIsFilterByUser(true)
    } else {
      setiIsFilterByUser(false)
    }
    dispatch(pointListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }
  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetDataList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const renderStatus = (status: string) => {
    return <StatusTag color={getPointStatus(status).color} text={getPointStatus(status).text} />
  }

  const renderType = (val: any, record: PointListData) => {
    const isReturn = record.status === 'return'
    const title = isReturn
      ? `รับคะแนนจากการรับคืนการใช้คะแนนไม่สำเร็จ`
      : `รับคะแนนจากการสั่งซื้อ - เลขที่คำสั่งซื้อ ${record.order_no}`
    return title
  }

  const columns = [
    {
      title: 'วันที่ทำรายการ',
      key: 'earn_date',
      dataIndex: 'earn_date',
      render: (date: string) => formatDateWithoutTime(date),
    },
    {
      title: 'Email/เบอร์โทรศัพท์',
      dataIndex: 'phone_no',
      key: 'phone_no',
      render: (val: string, record: PointListData) => record?.phone_no || record?.email || '-',
    },
    {
      title: 'รายการรับคะแนน',
      dataIndex: 'discount_type',
      key: 'discount_type',
      render: renderType,
    },
    {
      title: <Center>จำนวนคะแนนที่ได้รับ</Center>,
      dataIndex: 'earn_value',
      key: 'earn_value',
      render: (val: number) => (
        <Center>
          <PointAdd>+{numberWithComma(val)}</PointAdd> คะแนน
        </Center>
      ),
    },
    {
      title: 'ประเภทสมาชิก',
      key: 'type',
      dataIndex: 'type',
      render: (val: string) => getMenuTypeName(menuPointUserType, val),
    },
    {
      title: 'สถานะการรับคะแนน',
      key: 'status',
      dataIndex: 'status',
      render: renderStatus,
    },
  ]

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={20}>
          <Row gutter={[16, 16]}>
            <Col>
              <Space>
                <span>ค้นหาจาก</span>
                <SelectItem
                  name={'type'}
                  label={''}
                  isRequired={true}
                  value={filter.type}
                  menu={menuPointUserType}
                  placeHolder={'ค้นหาจาก'}
                  onChange={(val: any): void => onFilter('type', val)}
                  allowClear={true}
                />
              </Space>
            </Col>
            <Col md={8} xs={24}>
              <SearchInput
                placeholder={filter.type === 'buyer' ? 'ค้นหาเบอร์โทรศัพท์' : 'ค้นหาด้วย Email ร้านค้า'}
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const pointSummary = () => {
    return (
      <Row gutter={[16, 8]} justify="center">
        <Col style={{ textAlign: 'center' }}>
          <Button shape="round" type="primary" size={'large'} icon={<CrownOutlined />} onClick={() => {}}>
            คะแนนสะสมทั้งหมด {numberWithComma(pointList?.point_summary?.point || 0)} คะแนน
          </Button>
        </Col>
        {(pointList?.point_summary?.point_expire_next_day || 0) > 0 && (
          <Col>
            <Button
              shape="round"
              danger
              type="dashed"
              size={'large'}
              icon={<WarningOutlined />}
              onClick={() => {}}
            >
              คะแนนหมดอายุพรุ่งนี้ {numberWithComma(pointList?.point_summary?.point_expire_next_day || 0)}{' '}
              คะแนน
            </Button>
          </Col>
        )}
      </Row>
    )
  }
  return (
    <>
      {FilterContent}
      <br />
      {isFilterByUser && datas.length > 0 && pointSummary()}
      <br />
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={listEvent.IsLoading}
        paginationContent={PaginationContent}
      />
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    pointList: selectPointList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const Center = styled.div`
  text-align: center;
`

const PointAdd = styled.span`
  color: green;
  font-size: ${theme.typography.body3};
`

export default connect(mapStateToProps)(EarnPoint)
